import React from 'react';
import SplineChart from './charts/SplineChart';
import AreaSplineChart from './charts/AreaSplineChart';
import PercentageArea from './charts/PercentageArea';
import ColumnRange from './charts/ColumnRange';

const AnalyticsView = ({ trendsAnalytics, trendsAnalyticsMonth }) => {
    return (
        <>
            <SplineChart trends={trendsAnalytics} />
            <AreaSplineChart trends={trendsAnalytics}/>
            <PercentageArea trends={trendsAnalytics}/>
            <ColumnRange trends={trendsAnalyticsMonth}/>
        </>
    );
};

export default AnalyticsView;